<template>
  <div class="d-flex flex-row justify-content-around align-items-center">
    <div class="box-name">
      <span >{{ name }}</span>
    </div>
    <div>
      <div>
        <div class="slider-container">
          <input
            id="myRange"
            :style="{background:`linear-gradient(90deg, #3BB0FA ${sliderValue}%, #d6d6d6 0%)`}"
            :min="minValue"
            :max="maxValue"
            v-model="sliderValue"
            type="range"
            class="slider w-100 rounded rounded-12 btn-outline-0"
            @input.stop="changeRangeSlider"
            @keyup="addIntoPageWiseUndoRedoArray"
            @mouseup="addIntoPageWiseUndoRedoArray"
          >
        </div>
      </div>
    </div>
    <div class="box d-flex justify-content-center align-items-center">

      <span v-if="showColorPicker"><input
        v-model="selectedColor"
        type="color"
        @change="changeRangeSlider"></span>
      <span
        v-else
        class="box-value">{{ sliderValue }}</span>
    </div>
  </div>
</template>
<script>
import ImageFilterTypes from '@/mixins/ImageFilterTypes';
import EventBus from '@/EventBus';
import _ from 'lodash';

export default {
  name:   'Slider',
  mixins: [ImageFilterTypes.Mixin],
  props:  {
    name: {
      type:    String,
      default: '',
    },
    value: {
      type:    Number,
      default: 50,
    },
    isImageEffect: {
      type:    Boolean,
      default: true,
    },
    minValue: {
      type:    Number,
      default: 0,
    },
    maxValue: {
      type:    Number,
      default: 100,
    },
    showColorPicker: {
      type:    Boolean,
      default: false,
    },
    color: {
      type:    String,
      default: '#0000',
    },
  },
  data() {
    return {
      sliderValue:   this.value,
      selectedColor: this.color,
    };
  },
  methods: {
    changeRangeSlider() {
      // this.isImageEffect && _.debounce(this.$emit('updated', { name: this.name, value: parseInt(this.sliderValue, 10), color: this.selectedColor }), 500, { trailing: true });//The line was causing console error but was working as expected. Just copied the line below without loadash debounce
      this.isImageEffect && this.$emit('updated', { name: this.name, value: parseInt(this.sliderValue, 10), color: this.selectedColor });
    },
    addIntoPageWiseUndoRedoArray() {
      setTimeout(() => {
        EventBus.$emit('addIntoPageWiseUndoRedoArray', `Object Image ${this.name}changed`);
      });
    },
  },

};
</script>
<style lang="scss" scoped>
    .slider-container{
        width: 172px;
    }
    .slider{
        &:focus{
            border: none;
        }
        -webkit-appearance: none;
        height:4px;
        background: linear-gradient(90deg,rgb(214,214,214)60%,rgb(214,214,214)60%);
        opacity: 0.7;
        -webkit-transition: 0.2s;
        transition-opacity:0.2s;
    }

    .slider::-webkit-slider-thumb{
        -webkit-appearance: none;
        appearance: none;
        width:16px;
        height: 16px;
        background: white;
        border-radius: 50%;
        border:rgb(59, 176, 250) 2px solid ;
    }

    .slider::-moz-range-thumb{
        appearance: none;
        width:16px;
        height: 16px;
        background: white;
        border-radius: 50%;
        border:rgb(59, 176, 250) 2px solid ;
    }
    .slider::-webkit-slider-thumb:hover{
        cursor: pointer;
    }
    .box{
        background: #FFFFFF;
        /* Grey/20 */

        border: 1px solid #EDEDED;
        box-sizing: border-box;
        box-shadow: inset 0px 0px 8px rgba(0, 0, 0, 0.08);
        border-radius: 4px;
        width: 60px;
        height: 36px;
    }
    .box-value{
        font-family: Open Sans;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 24px;
        /* identical to box height, or 171% */

        text-align: center;

        /* Grey/80 */

        color: #3F3F3F;
    }
    .box-name{
        width: 76px;
        height: 20px;
        font-family: Open Sans;
        font-style: normal;
        font-weight: 600;
        font-size: 10px;
        line-height: 20px;
        /* identical to box height, or 200% */

        text-transform: uppercase;

        /* Grey/70 */

        color: #5F5F5F;

    }
</style>
